import React from 'react';
import NnPdfMenu from './NnPdfMenu';
import NnSkinMenu from './NnSkinMenu';
import NnSongMenu from './NnSongMenu';
import NnSongMenuLink from './NnSongMenuLink';
import { NavItem } from 'reactstrap';
import { FaCaretRight } from 'react-icons/fa';
import { IoIosMusicalNotes } from 'react-icons/io';
import { MdFastRewind } from 'react-icons/md';
import Menu from 'react-burger-menu/lib/menus/slide';

import './NnMenus.scss';

class NnMenus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMainMenu: false,
      showSkinMenu: false,
      showSongMenu: false,
    };
    this.props = props;
    this.closeAllMenus = this.closeAllMenus.bind(this);
    this.timingMenuClick = this.timingMenuClick.bind(this);
    this.showMenu = this.showMenu.bind(this);
  }

  render() {
    const closeAllMenusOnEsc = e => {
      e = e || window.event;
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.closeAllMenus();
      }
    };
    const props = { ...this.props, onClick: this.closeAllMenus };

    if (!props.song) return null;
    props.songId = props.song.id;

    let notation = props.letters ? 'Lettered' : 'Numbered';

    return (
      <div className="nn-menus">
        <Menu
          id="main-menu"
          burgerButtonClassName="nn-menu-button"
          customBurgerIcon={<i />}
          crossButtonClassName="menu-close-button"
          menuClassName={'menu'}
          itemListClassName={'menu-item-list'}
          itemClassName={'menu-item'}
          isOpen={this.state.showMainMenu}
          onStateChange={state => this.showMenu('showMainMenu', state.isOpen)}
          right
          width={'60%'}
        >
          <NavItem
            onClick={() => {
              this.closeAllMenus();
              this.props.rewind();
            }}
          >
            <NnSongMenuLink {...props}>
              <MdFastRewind />
              Rewind
            </NnSongMenuLink>
          </NavItem>

          <NavItem onClick={() => this.showMenu('showSongMenu', true)}>
            <NnSongMenuLink {...props}>
              <FaCaretRight />
              <span>Another Song</span>
            </NnSongMenuLink>
          </NavItem>

          <NavItem onClick={() => this.showMenu('showSkinMenu', true)}>
            <NnSongMenuLink {...props}>
              <FaCaretRight />
              <span>Change the skin</span>
            </NnSongMenuLink>
          </NavItem>

          <NavItem onClick={this.closeAllMenus}>
            <NnSongMenuLink {...props} timing={!props.timing}>
              <IoIosMusicalNotes />
              <span>{props.timing ? 'Hide' : 'Show'} Timing</span>
            </NnSongMenuLink>
          </NavItem>

          <NavItem onClick={this.closeAllMenus}>
            <NnSongMenuLink {...props} letters={!props.letters}>
              <IoIosMusicalNotes />
              <span>Use {props.letters ? 'Numbers' : 'Letters'}</span>
            </NnSongMenuLink>
          </NavItem>

          <NavItem onClick={() => this.showMenu('showPdfMenu', true)}>
            <NnSongMenuLink {...props}>
              <FaCaretRight />
              <span>Open pdf</span>
            </NnSongMenuLink>
          </NavItem>
        </Menu>

        <NnSongMenu
          isOpen={this.state.showSongMenu}
          onChange={state => this.showMenu('showSongMenu', state.isOpen)}
          onClose={this.closeAllMenus}
          skin={props.skin}
          songs={props.songs}
          onKeyDown={closeAllMenusOnEsc}
          timing={props.timing}
          letters={props.letters}
        />

        <NnSkinMenu
          isOpen={this.state.showSkinMenu}
          onChange={state => this.showMenu('showSkinMenu', state.isOpen)}
          onClose={this.closeAllMenus}
          onKeyDown={closeAllMenusOnEsc}
          songId={props.song.id}
          timing={props.timing}
          letters={props.letters}
          skin={props.skin}
        />

        <NnPdfMenu
          displayLetters={props.displayLetters}
          isOpen={this.state.showPdfMenu}
          notation={notation}
          onChange={state => this.showMenu('showPdfMenu', state.isOpen)}
          onClose={this.closeAllMenus}
          onKeyDown={closeAllMenusOnEsc}
          song={props.song}
        />
      </div>
    );
  }

  timingMenuClick() {}

  showMenu(stateName, isOpen) {
    let states = {
      showMainMenu: false,
      showPdfMenu: false,
      showSkinMenu: false,
      showSongMenu: false,
    };
    states[stateName] = isOpen;
    this.setState(states);
  }

  closeAllMenus() {
    this.setState({
      showMainMenu: false,
      showPdfMenu: false,
      showSkinMenu: false,
      showSongMenu: false,
    });
  }
}

export default NnMenus;
